import { reactive, toValue, watch } from 'vue'
import type { MaybeRefOrGetter, Reactive } from 'vue'
import type { FormFields } from '~/components/core/Form.vue'

export const FORM_DATA_SYNC = Symbol('form-data-sync')

export type UseFormDataOptions = {
   resetOn?: MaybeRefOrGetter<boolean | undefined>
}

export const useFormData = <T extends FormFields>(
   data: () => T,
   options?: UseFormDataOptions
): Reactive<T> => {
   const formData = reactive(data())
   const synced = formData as unknown as Record<symbol, number>

   const sync = (newData: T) => {
      Object.keys(formData).forEach((key) => {
         if (!(key in newData)) {
            delete formData[key]
         }
      })
      Object.assign(formData, newData)
      synced[FORM_DATA_SYNC] = (synced[FORM_DATA_SYNC] || 0) + 1
   }

   watch(() => data(), sync, { immediate: false })

   if (options?.resetOn) {
      watch(
         () => toValue(options.resetOn),
         (isOpen, wasOpen) => {
            if (isOpen && !wasOpen) sync(data())
         }
      )
   }

   return formData
}
